import fork from '@haaretz/l-fork.macro';

export default function nameValidator(name: string, type: 'firstName' | 'lastName') {
  const start = fork({ default: 'נא להזין', hdc: 'Enter' });
  const digitRegex = new RegExp('\\d');

  const ending =
    type === 'firstName'
      ? fork({ default: 'שם פרטי', hdc: 'First Name' })
      : fork({ default: 'שם משפחה', hdc: 'Last Name' });
  if (!name) {
    return `${start} ${ending}`;
  }

  if (typeof name !== 'string' || name.length < 2 || digitRegex.test(name)) {
    return fork({
      default: 'יש להזין שם המורכב מ-2 אותיות לפחות וללא מספרים',
      hdc: 'Please enter a name that contains 2 letters at least and no numbers',
    });
  }

  return `${start} ${ending}`;
}
